import styles from "./StickyAd.module.css";
import AdSense from "./AdSense";

export default function StickyAdsenseAd() {
  return (
    <AdSense
      format=""
      slot="8114317918"
      insStyle={{ display: "inline-block", width: "320px", height: "50px" }}
      contStyles={styles.cont}
      adStyles={styles.ad}
      showRemoveAds={false}
    />
  );
}
